module.exports = __webpack_public_path__ + "img/spinner.55af86fe.svg";